import { catalogAssetsImportResponse } from './catalog-assets-import-response';
import { ImportResponseEmitter } from '../models/import-response-emitter';
import { assetsImportResultsSchema } from '../schemas/assets-import-results.schema';
import { AssetsImportResponse } from '../../models/assets-import-response';
import { getErrorContext } from '../../utils/get-error-context';
import { reportToTrackjs } from '../../utils/report-to-trackjs';
import { Observable, pipe, switchMap } from 'rxjs';
import { chunk, subscribeOnce } from '@tmx/core';
import { AccountsApi, UserImport } from '@tmx/data-access';

const CHUNK_SIZE = 1000;

/** chimport - CHunked IMPORT. 🐒 */
export function chimportAssets(trackjsSource: string) {
  const emitter = new ImportResponseEmitter<AssetsImportResponse>();
  const importResponse$ = new Observable<AssetsImportResponse>((subscriber) => {
    emitter.register(subscriber);
  });

  const chimport = (assets: UserImport[]) => {
    const importResponse = new AssetsImportResponse(0, [], 0, true);

    let responseCount = 0;
    const subsets = chunk(assets, CHUNK_SIZE);

    const emit = () => {
      responseCount += 1;
      if (responseCount === subsets.length) {
        emitter.emit(importResponse);
      }
    };

    const assetLookup = new Map<string, UserImport>(
      assets.map((asset) => [asset.externalId, asset])
    );

    for (const subset of subsets) {
      const recordUnrecoverableError = () => {
        importResponse.unrecoverable += subset.length;
        emit();
      };

      subscribeOnce(
        AccountsApi.postAmsuiUsersImport(subset),
        (response) => {
          catalogAssetsImportResponse(
            response.errorDetails,
            assetLookup,
            subset.length,
            importResponse
          );
          emit();
        },
        (error) => {
          reportToTrackjs(
            trackjsSource,
            'Error importing assets',
            getErrorContext(error)
          );

          const assetsImportResults =
            assetsImportResultsSchema.safeParse(error);
          if (
            assetsImportResults.success &&
            assetsImportResults.data.status === 400
          ) {
            const errorDetails = assetsImportResults.data.error?.errorDetails;
            if (errorDetails) {
              catalogAssetsImportResponse(
                assetsImportResults.data.error?.errorDetails ?? [],
                assetLookup,
                subset.length,
                importResponse
              );
              emit();
            } else {
              recordUnrecoverableError();
            }
          } else {
            recordUnrecoverableError();
          }
        }
      );
    }
  };

  return pipe(
    switchMap(({ assets }: { assets: UserImport[] }) => {
      chimport(assets);
      return importResponse$;
    })
  );
}
